import { useMemo, useRef } from 'react';
import ListGroup from 'react-bootstrap/ListGroup';
import WordListItem from './WordListItem';
import WordListPlaceholder from './WordListPlaceholder';
import AlphaRail from './AlphaRail';
import { MIN_INDEX_ITEMS, getIndexLetters, getInitialLetter } from '../utils/alphaIndex';

const WordList = ({ entries, onEntrySelect, selectedEntry, withRail = true }) => {
  const containerRef = useRef(null);
  const letters = useMemo(() => getIndexLetters(entries || []), [entries]);

  if (!entries || entries.length === 0) return <WordListPlaceholder />;

  const showIndexRail = withRail && entries.length >= MIN_INDEX_ITEMS && letters.length > 0;

  const handleIndexClick = (letter) => {
    const target = containerRef.current?.querySelector(`[data-letter="${letter}"]`);
    if (target) {
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  const seenLetters = new Set();

  return (
    <div className='word-list-container' ref={containerRef}>
      <ListGroup className={showIndexRail ? 'word-list word-list--with-rail' : 'word-list'}>
        {entries.map((entry) => {
          const letter = getInitialLetter(entry);
          const isFirstOfLetter = !seenLetters.has(letter);
          if (isFirstOfLetter) {
            seenLetters.add(letter);
          }
          return (
            <WordListItem
              key={entry.id}
              entry={entry}
              active={selectedEntry && selectedEntry.word === entry.word}
              onClick={onEntrySelect}
              dataLetter={isFirstOfLetter ? letter : undefined}
            />
          );
        })}
      </ListGroup>
      <AlphaRail
        show={showIndexRail}
        letters={letters}
        containerRef={containerRef}
        onJump={handleIndexClick}
        entries={entries}
        variant='mobile'
      />
    </div>
  );
};

export default WordList;
